import { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { loadCurrentUser, refreshCSRF } from '../api/auth-api'
import { useAuthStore } from '../store/auth-store'

export function useSession() {
  const setUser = useAuthStore((state) => state.setUser)
  const setInitialized = useAuthStore((state) => state.setInitialized)
  const query = useQuery({
    queryKey: ['auth', 'me'],
    queryFn: async () => {
      const user = await loadCurrentUser()
      await refreshCSRF()
      return user
    },
    retry: false,
    staleTime: 30_000,
    refetchOnWindowFocus: true,
    refetchInterval: 60_000,
    refetchIntervalInBackground: false,
  })

  useEffect(() => {
    if (query.isSuccess) {
      setUser(query.data)
      setInitialized(true)
    }
    if (query.isError) {
      setUser(null)
      setInitialized(true)
    }
  }, [query.isError, query.isSuccess, query.data, setInitialized, setUser])

  return query
}
